<script>
  import { onMount } from 'svelte';
  import { show_message } from '../flash';
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../translate.js';

  // component options  ------------------------------------------------------ //

  export let id;
  export let label;
  export let name;
  export let variant = 'outlined';
  export let value = null;
  export let width = '100%';
  export let margin_top = null;
  export let leading_icon = null;
  export let trailing_icon = null;
  export let inline = false;
  export let is_minmax_val = false;
  export let max_val;
  export let min_val = 0;
  export let time_hours_validation;
  export let show_tooltip = false;
  export let disabled = false;
  export let amount = 0.5;

  // internal variables ------------------------------------------------------ //

  let empty = true;
  let focused = false;
  let validated = false;
  let errors = null;
  let data_cy = null;
  let has_focused = false;

  // utility functions -------------------------------------------------------- //

  const toggle_focus = () => {
    focused = !focused;
    has_focused = true;
    // if (value === null) value = 0;
    if (focused === false && value === 0) value = null;
    // check_min_val(value);
    if (!focused) {
      check_min_val();
    }
  };

  const value_minus = () => {
    if (value > amount) {
      value = parseFloat(value) - amount;
    }
  };

  const value_plus = () => {
    if (focused === false) focused = true;
    if (value === null) {
      value = 1;
    } else {
      value = parseFloat(value) + amount;
    }
  };

  const init_field = () => {
    // distance-input
    const distance_input = document.getElementById('distance-input');
    if (distance_input) {
      distance_input.style.paddingLeft = `${width / 2} px`;
    }
  };

  const change_comma = val => {
    if (!!value) {
      if (val.toString().includes(',')) {
        value = Number(value.replace(',', '.'));
      }
    }
  };

  const check_min_val = () => {
    time_hours_validation = true;
    if (parseFloat(value) < min_val) {
      time_hours_validation = false;
      show_message(t9n(TS.ORDER_NEW_TIME_ERROR_MINIMUM, min_val), 'error');
    }

    let decimal = Number((value - Math.floor(value)).toFixed(1));
    if (decimal !== amount && decimal !== 0) {
      time_hours_validation = false;
      // show_message(`The amount must be in increments of .5 (x.0 or x.5).`, 'error');
      show_message(t9n(TS.ORDER_NEW_TIME_ERROR_INCREMENT), 'error');
    }
  };

  onMount(init_field);

  const validate_val = val => {
    let regExp = /[a-zA-Z]/g;
    if (regExp.test(val)) {
      value = null;
    }
  };
  // reactive functions ------------------------------------------------------- //
  // $: if (parseFloat(value) <= min_val) {
  //   value = min_val;
  // }

  // $: check_min_val(value);
  $: validate_val(value);
  $: if (parseFloat(value) > max_val) {
    value = max_val;
  }

  // $: console.log({width})
  $: change_comma(value);
  $: empty = !value;
</script>

<svelte:options accessors={true} />

<div class:inline-field-container={inline}>
  <div
    style={`position:relative; margin-top: ${margin_top}`}
    class:mobile-width-v0={width === '150px'}
    class:mobile-width-v1={width === '155px'}
    class:mobile-width-v2={width === '199px'}
    class:mobile-width-v3={width === '310px'}>

    {#if disabled}
      <i
        class="btn-minus material-icons mdc-text-field__icon"
        style="color:grey; opacity: 0.4">
        remove
      </i>
    {:else if value === min_val}
      <i
        class="btn-minus material-icons mdc-text-field__icon"
        style="color:grey; opacity: 0.4">
        remove
      </i>
    {:else}
      <a
        href="javascript:;"
        data-cy="decrease-num"
        class="btn-minus"
        on:click={() => value_minus()}>
        <i class="material-icons mdc-text-field__icon">remove</i>
      </a>
    {/if}

    {#if disabled}
      <i
        class="btn-plus material-icons mdc-text-field__icon"
        style="color:grey; opacity: 0.4">
        add
      </i>
    {:else if is_minmax_val === true}
      {#if value === max_val}
        <i
          class="btn-plus material-icons mdc-text-field__icon"
          style="color:grey; opacity: 0.4">
          add
        </i>
      {:else}
        <a
          href="javascript:;"
          data-cy="add-num"
          class="btn-plus"
          on:click={() => value_plus()}>
          <i class="material-icons mdc-text-field__icon">add</i>
        </a>
      {/if}
    {:else}
      <a
        href="javascript:;"
        data-cy="add-num"
        class="btn-plus"
        on:click={() => value_plus()}>
        <i class="material-icons mdc-text-field__icon">add</i>
      </a>
    {/if}

  </div>

  <div
    {id}
    class="mdc-text-field text-field mdc-text-field--with-trailing-icon
    mdc-text-field--with-leading-icon"
    class:mdc-text-field--outlined={variant === 'outlined'}
    class:mdc-text-field--focused={focused}
    class:mdc-text-field--disabled={disabled}
    class:mobile-width-v0={width === '150px'}
    class:mobile-width-v1={width === '155px'}
    class:mobile-width-v2={width === '199px'}
    class:mobile-width-v3={width === '310px'}>

    <input
      type="text"
      id="distance-input"
      class="mdc-text-field__input"
      {name}
      bind:value
      {leading_icon}
      {trailing_icon}
      {disabled}
      on:focus={toggle_focus}
      on:input
      on:keyup
      on:change
      on:blur={toggle_focus} />

    {#if variant === 'outlined'}
      <div
        class="mdc-notched-outline"
        style="border-color: red;"
        class:mdc-text-field--disabled={disabled}
        class:mdc-notched-outline--upgraded={focused || !empty}
        class:mdc-notched-outline--notched={focused || !empty}>
        <div class="mdc-notched-outline__leading" />

        <div class="mdc-notched-outline__notch">
          <label
            class="mdc-floating-label"
            class:mdc-floating-label--float-above={focused || !empty}>
            {label}
          </label>
        </div>

        <div class="mdc-notched-outline__trailing" />
      </div>
    {:else if variant === 'filled'}
      <div class="mdc-line-ripple" />
      <label
        class:mdc-floating-label--float-above={focused || !empty}
        class="mdc-floating-label">
        {label}
      </label>
    {/if}
  </div>

  {#if !has_focused && min_val > 0 && show_tooltip}
    <div class="tooltip-default ">
      <span id="tooltip_def" class="tooltip-text tooltip-top">
        {`${t9n(TS.NEW_ORDER_MIN_VAL)} ${min_val}`}
      </span>
    </div>
  {/if}
</div>

<style>
  .tooltip-default {
    position: relative;
    font-size: 13px;
    top: -81px;
    animation: transition_in 0.6s;
  }

  .tooltip-default .tooltip-top {
    position: absolute;
    z-index: 5;
    bottom: 100%;
    right: 0;
    left: 20%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    width: 77%;
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 30px;
    left: -90px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }

  .mdc-text-field {
    width: 100%;
    margin-bottom: 16px;
  }

  .mdc-text-field-helper-line {
    position: relative;
    top: -16px;
  }

  .reveal_password {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    z-index: 2;
    pointer-events: all;
  }

  .inline-field-container {
    display: inline-block;
  }

  ul.errors {
    padding-left: 0;
    position: relative;
    top: -16px;
    text-align: left;
  }

  .btn-minus {
    z-index: 1;
    position: absolute;
    top: 15px;
    left: 10px;
  }

  .btn-plus {
    z-index: 1;
    position: absolute;
    right: 10px;
    top: 15px;
  }

  a:link {
    text-decoration: none;
    color: var(--mdc-theme-primary);
  }

  a:hover {
    text-decoration: none;
    color: var(--mdc-theme-secondary);
  }

  /* Desktop Mode
      *******************************************************/
  @media (min-width: 1025px) {
    .mobile-width-v0 {
      width: 150px;
    }

    .mobile-width-v1 {
      width: 155px;
    }

    .mobile-width-v2 {
      width: 199px;
    }

    .mobile-width-v3 {
      width: 310px;
    }
  }

  /* Mobile Mode
        *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .mobile-width-v0 {
      width: 100%;
    }

    .mobile-width-v1 {
      width: 100%;
    }

    .mobile-width-v2 {
      width: 199px;
    }

    .mobile-width-v3 {
      width: 100%;
    }
  }
</style>
